import React, { memo } from 'react'
import classNames from 'classnames'
import RightArrowIcon from 'transfix-icons/build/RightArrowIcon'
import { TIconComponent } from 'transfix-icons/types'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

export interface INavListFooterIndicatorProps {
  label?: string
  icon?: TIconComponent
  onClick?: () => void
  /**
   * Toggles whether to hide certain elements
   * @default true
   */
  isNavExpanded?: boolean
  /**
   * Toggles whether to show the indicator
   * @default false
   */
  shouldShowIndicator?: boolean
}

const useNavListFooterIndicatorStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    background: brandColors.gold2,
    borderRadius: '8px 8px 0 0',
    padding: theme.spacing(0.5, 1),
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    minHeight: 32, // From design
    transition: 'background 300ms',
  },
  rootExpanded: {
    padding: theme.spacing(0.5, 3),
    justifyContent: 'space-between',
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
}))

export const NavListFooterIndicator = memo<INavListFooterIndicatorProps>(
  ({ icon: IconComponent, isNavExpanded = true, label, onClick }) => {
    const classes = useNavListFooterIndicatorStyles({ isNavExpanded })
    return (
      <Box
        onClick={onClick}
        data-test='nav-list-footer-indicator'
        className={classNames(classes.root, { [classes.rootExpanded]: isNavExpanded })}>
        <div className={classes.labelWrapper}>
          {IconComponent && <IconComponent size='large' />}
          {isNavExpanded && (
            <Typography variant='button' className={classes.label}>
              {label}
            </Typography>
          )}
        </div>

        {isNavExpanded && <RightArrowIcon size='medium' />}
      </Box>
    )
  }
)

export default NavListFooterIndicator
